import { Button, Grid } from '@mui/material';
import { ILoadFile } from './ILoadFile';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import './loadFile.css';
import useDownloader from "react-use-downloader";

export default function CustomisedLoadFile({ fileUrl, isMulti, fileName, fileType }: ILoadFile) {
    // const { download } = useDownloader();
    let isImg = fileType?.includes("Image") || fileType?.includes("image");
    // const filename = `pdf`;
    const handleDownloda = () => {
        // download(fileUrl!, filename);
        window.open(fileUrl);
    };
    let url = fileUrl + '/true';
    const handleImageClick = () => {
        let blob = fileUrl?.includes('blob');
        if (fileUrl && blob) {
            window.open(fileUrl, '_blank');
        } else if (fileUrl) {
            window.open(url, '_blank');
        }
    };
    return (
        <>
            <div className="imageUpload" >
                <a href={url!} target="_blank" style={{ objectFit: 'cover' }}>
                    {isImg ?
                        <img
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                maxHeight: '100%',
                                height: '100%'
                            }}
                            className="text-center block m-auto"
                            src={fileUrl ? fileUrl : '/images/login.svg'}
                            onClick={handleImageClick}
                        /> :
                        <span
                            onClick={handleDownloda}
                            className="uploadImage verticalForuploadImage"
                            style={{
                                padding: "1vh", display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <InsertDriveFileOutlinedIcon className='uploadImageIcon' />
                        </span>
                    }
                </a>


            </div>
            {
                isMulti ? <div style={{
                    backgroundColor: 'black',
                    opacity: '70%',
                    marginTop: '-6.5vh',
                    borderBottomRightRadius: '5px',
                    borderBottomLeftRadius: '5px',
                    height: '5vh'
                }}>
                    <Grid container xs={12} style={{
                        height: '100%',
                        alignContent: 'center'
                    }}>
                        <Grid item xs={10} style={{ paddingRight: '1vw', alignContent: 'center' }}>

                            <p style={{ color: '#fff' }}>{fileName}</p>
                        </Grid>
                        <Grid item xs={2} style={{
                            textAlign: 'end',
                            paddingLeft: '1vw'
                        }}
                        >
                            <Button>
                                <DeleteOutlineIcon style={{ color: '#fff' }} />
                            </Button>
                        </Grid>

                    </Grid>
                </div>
                    : null
            }

        </>
    );
}

